import React from "react";
import { useNavigation } from "react-uicomp";

// ROUTES
import HomePage from "../homePage/Homepage";
import NotFoundPage from "../notFoundPage/NotFoundPage";
import BookletPage from "../BookletPage/BookletPage";
import EventsPage from "../eventsPage/EventsPage";
import EventsDetailPage from "../eventsDetailPage/EventsDetailPage";
import NewsPage from "../newsPage/NewsPage";
import NewsDetailPage from "../newsDetailPage/NewsDetailPage";
import PressPage from "../pressPage/PressPage";
import PressDetailPage from "../pressDetailPage/PressDetailPage";
import ContactUsPage from "../contactUsPage/ContactUsPage";

// FACILITIES
import LaboratoriesPage from "../laboratoriesPage/LaboratoriesPage";
import SeminarPage from "../seminarPage/SeminarPage";
import TraineesHostelPage from "../traineesHostelPage/TraineesHostelPage";
import TrainingHallPage from "../trainingHallPage/TrainingHallPage";
import LibraryPage from "../libraryPage/LibraryPage";
import ResearchFarmPage from "../researchFarmPage/ResearchFarmPage";
import AgrometStationPage from "../agrometStationPage/AgrometStationPage";

//ABOUT US PAGE
import {
  StationChiefDesk,
  AboutArsp,
  CurrentResearch,
  ListofStationChief,
  WorkingStrategies,
  Organogram,
  ListOfStaff,
  CitizenCharter,
} from "../AboutPages";

import CvPage from "../cvPage/CvPage";
// GALLERY PAGE
import { PhotoGalleryPage, VideoGalleryPage } from "../galleryPage";

import { ResearchArticlePage } from "../downloadsPage";

import BooksPage from "../BooksPage/BooksPage";
import AnnualReportPage from "../AnnualReportPage/AnnualReportPage";
import FarmerCornerPage from "../FarmerCornerPage/FarmerCornerPage";

// Redirect component
const Redirect = ({ to }) => {
  const { navigation } = useNavigation();
  const { navigate } = navigation;

  React.useEffect(() => {
    navigate(to);
  }, [navigate, to]);

  return null;
};

export const publicPaths = [
  {
    name: "Home",
    path: "/",
    component: HomePage,
    restricted: true,
  },
  {
    name: "About Us",
    path: "/about-us",
    component: () => <Redirect to="/about-us/about-arsp" />,
    restricted: true,
    subPaths: [
      {
        name: "From Station Chief's Desk",
        path: "/from-station-chief-desk",
        // component: CvPage,
        component: StationChiefDesk,
        restricted: true,
        props: "About Us",
      },
      {
        name: "About ARSP",
        path: "/about-arsp",
        component: AboutArsp,
        restricted: true,
        props: "About Us",
      },
      {
        name: "Current Research Projects",
        path: "/current-research-projects",
        component: CurrentResearch,
        restricted: true,
        props: "About Us",
      },
      {
        name: "List of Station Chiefs",
        path: "/list-of-station-chiefs",
        component: ListofStationChief,
        restricted: true,
        props: "About Us",
      },
      {
        name: "Working Strategies",
        path: "/working-strategies",
        component: WorkingStrategies,
        restricted: true,
        props: "About Us",
      },
      {
        name: "Organogram",
        path: "/organogram",
        component: Organogram,
        restricted: true,
        props: "About Us",
      },
      {
        name: "List of Staffs",
        path: "/list-of-staffs",
        component: ListOfStaff,
        restricted: true,
        props: "About Us",
      },
      {
        name: "Citizen Charter",
        path: "/citizen-charter",
        component: CitizenCharter,
        restricted: true,
        props: "About Us",
      },
    ],
  },
  {
    name: "Farmers Corner",
    path: "/farmers-corner",
    component: FarmerCornerPage,
    restricted: true,
  },
  {
    name: "Publications",
    path: "/publications",
    component: HomePage,
    restricted: true,
    subPaths: [
      {
        name: "Books",
        path: "/books",
        component: BooksPage,
        restricted: true,
        props: "Publications",
      },
      {
        name: "Booklet",
        path: "/booklet",
        component: BookletPage,
        restricted: true,
        props: "Publications",
      },
      {
        name: "Annual Report",
        path: "/annual-report",
        component: AnnualReportPage,
        restricted: true,
        props: "Publications",
      },
    ],
  },
  {
    name: "Facilities",
    path: "/facilities",
    component: () => <Redirect to="/facilities/laboratories" />,
    restricted: true,
    subPaths: [
      {
        name: "Laboratories",
        path: "/laboratories",
        component: LaboratoriesPage,
        restricted: true,
        props: "Facilities",
      },
      {
        name: "Seminar Hall",
        path: "/seminar-hall",
        component: SeminarPage,
        restricted: true,
        props: "Facilities",
      },
      {
        name: "Trainee's Hostel",
        path: "/trainees-hostel",
        component: TraineesHostelPage,
        restricted: true,
        props: "Facilities",
      },
      {
        name: "Training Hall",
        path: "/training-hall",
        component: TrainingHallPage,
        restricted: true,
        props: "Facilities",
      },
      {
        name: "Library",
        path: "/library",
        component: LibraryPage,
        restricted: true,
        props: "Facilities",
      },
      {
        name: "Research Farm",
        path: "/resarch-farm",
        component: ResearchFarmPage,
        restricted: true,
        props: "Facilities",
      },
      {
        name: "Agromet Station",
        path: "/agromet-station",
        component: AgrometStationPage,
        restricted: true,
        props: "Facilities",
      },
    ],
  },
  {
    name: "Notice Board",
    path: "/notice-board",
    component: () => <Redirect to="/notice-board/news-notices" />,
    restricted: true,
    subPaths: [
      {
        name: "News & Notices",
        path: "/news-notices",
        component: NewsPage,
        restricted: true,
        props: "Notice Board",
        subPaths: [
          {
            name: "News & Notices Detail",
            path: "/:id",
            component: NewsDetailPage,
            restricted: true,
            visible: false,
          },
        ],
      },
      {
        name: "Events",
        path: "/events",
        component: EventsPage,
        restricted: true,
        props: "Notice Board",
        subPaths: [
          {
            name: "Events Detail",
            path: "/:id",
            component: EventsDetailPage,
            restricted: true,
            visible: false,
          },
        ],
      },
      {
        name: "Press Release",
        path: "/press-release",
        component: PressPage,
        restricted: true,
        props: "Notice Board",
        subPaths: [
          {
            name: "Press Release Detail",
            path: "/:id",
            component: PressDetailPage,
            restricted: true,
            visible: false,
          },
        ],
      },
    ],
  },
  {
    name: "Gallery",
    path: "/gallery",
    component: () => <Redirect to="/gallery/photo-gallery" />,
    restricted: true,
    subPaths: [
      {
        name: "Photo Gallery",
        path: "/photo-gallery",
        component: PhotoGalleryPage,
        restricted: true,
        props: "Gallery",
      },
      {
        name: "Video Gallery",
        path: "/video-gallery",
        component: VideoGalleryPage,
        restricted: true,
        props: "Gallery",
      },
    ],
  },
  {
    name: "Downloads",
    path: "/downloads",
    component: () => <Redirect to="/downloads/research-articles" />,
    restricted: true,
    subPaths: [
      {
        name: "Research Articles",
        path: "/research-articles",
        component: ResearchArticlePage,
        restricted: true,
        props: "Downloads",
      },
    ],
  },
  {
    name: "Contact Us",
    path: "/contact-us",
    component: ContactUsPage,
    restricted: true,
  },
  {
    path: null,
    component: NotFoundPage,
  },
];

export const privatePaths = [];
